var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.454 6.10245C13.806 5.96585 14.194 5.96585 14.546 6.10245L19.9904 8.21579C20.287 8.33087 20.5426 8.5369 20.723 8.80637C20.9034 9.07583 21 9.39587 21 9.72371V14.0414C21 15.387 20.638 16.7061 19.9546 17.8508C19.2712 18.9954 18.2933 19.9205 17.1306 20.5223L14.5219 21.8724C14.3599 21.9563 14.1812 22 14 22C13.8188 22 13.6401 21.9563 13.4781 21.8724L10.8694 20.5223C9.7067 19.9205 8.72882 18.9954 8.04539 17.8508C7.36196 16.7061 6.99997 15.387 7 14.0414V9.72371C6.99996 9.39587 7.0966 9.07583 7.27701 8.80637C7.45741 8.5369 7.71298 8.33087 8.00956 8.21579L13.454 6.10245ZM14 7.61037L8.55556 9.72371V14.0414C8.55573 15.0879 8.83742 16.1137 9.36905 17.0038C9.90067 17.8939 10.6612 18.6133 11.5656 19.0812L14 20.3428V7.61037Z",
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.a6bd9cd7726ba2e79cf938a60c64d8b6.svg";
export { ForwardRef as ReactComponent };